module.exports = __webpack_public_path__ + "static/img/2- 6.2.5.7eaa74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/2- 6.2.5.png
// module id = nNW6
// module chunks = 0